import { FormColumn } from 'components/registration/v2/RegistrationParticipantList';
import {
  ActionType,
  LoadingType,
  RegParticipantState,
  SetActiveFiltersPayload,
  SetColumnsPayload,
  SetExportModalTitlePayload,
  SetFiltersPayload,
  SetFormResultPayload,
  SetLoadingPayload,
  SetSearchTermPayload,
  SetSelectedColumnsPayload,
} from './types';

export interface RegParticipantAction {
  type: ActionType;
  loading?: { loadingType: LoadingType; isLoading: boolean };
  payload?:
    | SetActiveFiltersPayload
    | SetExportModalTitlePayload
    | SetColumnsPayload
    | SetSearchTermPayload
    | SetFiltersPayload
    | SetLoadingPayload
    | SetSelectedColumnsPayload
    | SetFormResultPayload;
}

export const registrationParticipantsReducer = (
  state: RegParticipantState,
  action: RegParticipantAction
) => {
  switch (action.type) {
    case ActionType.SetLoading: {
      const { loadingType, isLoading } = action.loading as SetLoadingPayload;
      return {
        ...state,
        loading: {
          ...state.loading,
          [loadingType]: isLoading,
        },
      };
    }
    case ActionType.SetActiveFilters: {
      const { activeFilters } = action.payload as SetActiveFiltersPayload;
      return { ...state, activeFilters };
    }
    case ActionType.SetExportModalTitle: {
      const { exportModalTitle } = action.payload as SetExportModalTitlePayload;
      return { ...state, exportModalTitle };
    }
    case ActionType.SetFormResults: {
      const { formResults } = action.payload as SetFormResultPayload;
      return { ...state, formResults };
    }
    case ActionType.SetSelectedColumns: {
      const { selectedColumns: selectedColumnNames } =
        action.payload as SetSelectedColumnsPayload;
      const selectedColumns: FormColumn[] = state.columns.filter((column) => column.isRequired || selectedColumnNames.includes(column.name));
      return { ...state, selectedColumns: selectedColumns.map((c) => c.name) };
    }
    case ActionType.SetColumns: {
      const { columns } = action.payload as SetColumnsPayload;
      return { ...state, columns };
    }
    case ActionType.SetFilters: {
      const { filters } = action.payload as SetFiltersPayload;
      return { ...state, filters };
    }
    case ActionType.SetSearchTerm: {
      const { searchTerm } = action.payload as SetSearchTermPayload;
      return { ...state, searchTerm };
    }
    default:
      return state;
  }
};
